import { ChatWidget } from './ChatWidget';
import { useChatUi } from '../../context/ChatUiContext';
import './chat-widget.css';

export function ChatFloatingButton() {
  const { isOpen, toggleChat, closeChat } = useChatUi();

  return (
    <>
      {isOpen ? (
        <>
          <button
            type="button"
            className="chat-overlay"
            onClick={closeChat}
            aria-label="Cerrar chat de soporte"
          />
          <ChatWidget onClose={closeChat} />
        </>
      ) : null}
      <button
        type="button"
        className="chat-float"
        onClick={toggleChat}
        aria-label={isOpen ? 'Cerrar chat de soporte' : 'Abrir chat de soporte'}
        title="Chat de soporte"
      >
        {isOpen ? (
          <span className="chat-float__icon" aria-hidden="true">
            ×
          </span>
        ) : (
          <svg viewBox="0 0 24 24" aria-hidden="true" className="chat-float__icon">
            <path
              fill="currentColor"
              d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2m0 14H6l-2 2V4h16v12Z"
            />
          </svg>
        )}
      </button>
    </>
  );
}
